<template>
    <div class="make-model-bot-chat">
        <div class="make-model-bot-chat__container">
            <div v-if="chatMessage.type === MakeModelChatType.BotMessage"><chat-message-component
                    :chatMessage="chatMessage" /></div>
            <div v-if="chatMessage.type === MakeModelChatType.UserMessage"><chat-message-component
                    :chatMessage="chatMessage" /></div>
            <div v-if="chatMessage.type === MakeModelChatType.InfoMessage"><chat-message-component
                :chatMessage="chatMessage" /></div>
            <div v-if="chatMessage.type === MakeModelChatType.Image"><make-model-vehicle-image-component
                    :chatMessage="chatMessage" /></div>
            <div v-if="chatMessage.type === MakeModelChatType.Answers"><answer-buttons-component
                    @onMakeModelAnswerSelected="answerCallback($event)" @onMakeModelHelpSelected="helpMeCallBack()" @onChatFinished="onChatFinished"
                    :chatMessage="chatMessage" :conversationId="conversationId" /></div>
        </div>
    </div>
</template>

<script lang="ts">

import ChatMessage from '@/models/vehicle/makeModelBot/chatMessage';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import MakeModelChatType from '../../../enums/MakeModelChatType';
import ChatMessageComponent from './ChatMessageComponent.vue';
import AnswerButtonsComponent from './AnswerButtonsComponent.vue';
import MakeModelVehicleImageComponent from './MakeModelVehicleImageComponent.vue';

@Component({
    components: {
        'chat-message-component': ChatMessageComponent,
        'make-model-vehicle-image-component': MakeModelVehicleImageComponent,
        'answer-buttons-component': AnswerButtonsComponent
    }
})
export default class MakeModelBotChatComponent extends Vue {
    @Prop({ default: 'Car Configurator' })
    public title!: string;

    @Prop({ default: 'Configuring a car can be hard! We are here to simplify that process.' })
    public initialMessage!: string;

    @Prop({ default: '' })
    public chatMessage!: ChatMessage;

    @Prop({ default: '' })
    public conversationId!: string;

    public MakeModelChatType = MakeModelChatType;

    public answerCallback($event) {
        this.$emit('onMakeModelAnswerSelected', $event);
    }

    public helpMeCallBack() {
        this.$emit('onMakeModelHelpSelected');
    }

    public onChatFinished() {
        this.$emit('onChatFinished');
    }

    public mounted() {
        this.chatMessage.isFinished = true;
    }
}
</script>
